(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["distrigo-catalogue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    document.querySelectorAll('[data-d-catalog]').forEach((root) => {
      root.querySelectorAll('[data-catalog-viewer]').forEach((viewer) => {
        const button = viewer.querySelector('[data-load-viewer]');
        if (!button) return;
        button.addEventListener('click', () => {
          const frame = document.createElement('iframe');
          frame.src = viewer.dataset.viewerUrl;
          frame.title = viewer.dataset.viewerTitle || 'Catalogue produit';
          frame.loading = 'lazy';
          frame.allowFullscreen = true;
          viewer.replaceChildren(frame);
        }, { once: true });
      });

      root.querySelectorAll('[data-index-root]').forEach((indexRoot) => {
        const input = indexRoot.querySelector('[data-index-search]');
        const list = indexRoot.querySelector('[data-index-list]');
        const count = indexRoot.querySelector('[data-index-count]');
        const reset = indexRoot.querySelector('[data-index-reset]');
        if (!input || !list) return;
        const items = Array.from(list.querySelectorAll('[data-index-item]'));
        const update = () => {
          const term = normalize(input.value.trim());
          let visible = 0;
          items.forEach((item) => {
            const match = !term || normalize(item.textContent).includes(term);
            item.hidden = !match;
            if (match) visible += 1;
          });
          if (count) {
            const unit = visible === 1 ? indexRoot.dataset.indexUnitSingular : indexRoot.dataset.indexUnitPlural;
            count.textContent = `${visible} ${unit || 'résultat'}${unit ? '' : visible === 1 ? '' : 's'} affiché${visible === 1 ? 'e' : 'es'}`;
          }
        };
        input.addEventListener('input', update);
        if (reset) reset.addEventListener('click', () => {
          input.value = '';
          update();
          input.focus();
        });
      });

      const browser = root.querySelector('[data-reference-browser]');
      if (!browser) return;

      const familyButtons = Array.from(root.querySelectorAll('[data-family-select]'));
      const references = Array.from(browser.querySelectorAll('[data-reference-item]'));
      const search = browser.querySelector('[data-reference-search]');
      const reset = browser.querySelector('[data-reference-reset]');
      const title = browser.querySelector('[data-reference-title]');
      const count = browser.querySelector('[data-reference-count]');
      const empty = browser.querySelector('[data-reference-empty]');
      const more = browser.querySelector('[data-reference-more]');
      const moreWrap = browser.querySelector('[data-reference-more-wrap]');
      const pageSize = 24;
      let visibleLimit = pageSize;
      let activeFamily = familyButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.familySelect || 'entretien-climatisation';

      const updateReferences = () => {
        const term = normalize(search?.value.trim());
        const matches = references.filter((item) => {
          const inFamily = item.dataset.family === activeFamily;
          return inFamily && (!term || normalize(item.textContent).includes(term));
        });

        references.forEach((item) => { item.hidden = true; });
        matches.slice(0, visibleLimit).forEach((item) => { item.hidden = false; });

        const shown = Math.min(visibleLimit, matches.length);
        if (count) {
          const noun = shown === 1 ? 'référence' : 'références';
          count.textContent = matches.length === 0
            ? 'Aucune référence trouvée'
            : `${shown} ${noun} affichée${shown > 1 ? 's' : ''} sur ${matches.length}`;
        }
        if (empty) empty.hidden = matches.length !== 0;
        const canShowMore = shown < matches.length;
        if (more) more.hidden = !canShowMore;
        if (moreWrap) moreWrap.hidden = !canShowMore;
      };

      const selectFamily = (button, shouldScroll) => {
        activeFamily = button.dataset.familySelect;
        visibleLimit = pageSize;
        if (search) search.value = '';
        familyButtons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        if (title) title.textContent = button.dataset.familyLabel;
        updateReferences();

        if (window.history?.replaceState) {
          window.history.replaceState(null, '', `#famille-${activeFamily}`);
        }
        if (shouldScroll) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          browser.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          browser.focus({ preventScroll: true });
        }
      };

      familyButtons.forEach((button) => {
        button.addEventListener('click', () => selectFamily(button, true));
      });

      if (search) {
        search.addEventListener('input', () => {
          visibleLimit = pageSize;
          updateReferences();
        });
      }
      if (reset && search) {
        reset.addEventListener('click', () => {
          search.value = '';
          visibleLimit = pageSize;
          updateReferences();
          search.focus();
        });
      }
      if (more) {
        more.addEventListener('click', () => {
          visibleLimit += pageSize;
          updateReferences();
        });
      }

      const requestedFamily = window.location.hash.replace('#famille-', '');
      const requestedButton = familyButtons.find((button) => button.dataset.familySelect === requestedFamily);
      if (requestedButton) selectFamily(requestedButton, false);
      else updateReferences();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-distrigo-contact-form]').forEach((form) => {
    const startedAt = performance.now();
    const submitButton = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-distrigo-contact-status]');
    const trap = form.querySelector('[data-distrigo-contact-trap]');

    form.addEventListener('submit', (event) => {
      if (trap && trap.value.trim() !== '') {
        event.preventDefault();
        if (status && submitButton) status.textContent = submitButton.dataset.blockedMessage;
        return;
      }

      if (performance.now() - startedAt < 2000) {
        event.preventDefault();
        if (status && submitButton) status.textContent = submitButton.dataset.fastMessage;
      }

      if (event.defaultPrevented) return;

      const customerType = form.querySelector('[name="contact[type_de_client]"]');
      sessionStorage.removeItem('distrigo-contact-lead-sent:' + window.location.pathname);
      if (customerType && customerType.value) {
        sessionStorage.setItem('distrigo-contact-lead-type', customerType.value);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-contact-forms"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-distrigo-forms-host]').forEach((host) => {
    host.addEventListener('submit', () => {
      const sentKey = 'distrigo-shopify-form-lead:' + window.location.pathname;
      if (sessionStorage.getItem(sentKey)) return;

      const sendLead = () => {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', 'generate_lead', { lead_source: 'shopify_forms' });
        sessionStorage.setItem(sentKey, '1');
      };

      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (!error && window.Shopify.customerPrivacy.analyticsProcessingAllowed()) sendLead();
          }
        );
      }
    }, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-event-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('distrigo-event-bar')) {
    customElements.define('distrigo-event-bar', class extends HTMLElement {
      connectedCallback() {
        const end = Date.parse(this.dataset.endsAt || '');
        const key = this.dataset.storageKey;
        let dismissed = false;

        try { dismissed = sessionStorage.getItem(key) === 'dismissed'; } catch (error) { dismissed = false; }

        if ((Number.isFinite(end) && Date.now() >= end) || dismissed) {
          this.hidden = true;
          return;
        }

        this.querySelector('.d-event__close')?.addEventListener('click', () => {
          this.hidden = true;
          try { sessionStorage.setItem(key, 'dismissed'); } catch (error) { /* Storage may be unavailable. */ }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.d-header__drawer a');
    if (link) link.closest('details')?.removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('distrigo-home')) {
    customElements.define('distrigo-home', class extends HTMLElement {
      connectedCallback() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const reveals = this.querySelectorAll('[data-reveal]');

        if (!reducedMotion && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: .12, rootMargin: '0px 0px -40px' });
          reveals.forEach((element) => observer.observe(element));
        } else {
          reveals.forEach((element) => element.classList.add('is-visible'));
        }

        const media = this.querySelector('[data-hero-media]');
        const hero = this.querySelector('.d-home__hero');
        if (!reducedMotion && media && hero) {
          hero.addEventListener('pointermove', (event) => {
            const bounds = hero.getBoundingClientRect();
            media.style.setProperty('--mx', ((event.clientX - bounds.left) / bounds.width - .5).toFixed(3));
            media.style.setProperty('--my', ((event.clientY - bounds.top) / bounds.height - .5).toFixed(3));
          }, { passive: true });

          let queued = false;
          const updateScroll = () => {
            const bounds = hero.getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1, -bounds.top / Math.max(bounds.height, 1)));
            media.style.setProperty('--sy', progress.toFixed(3));
            queued = false;
          };
          window.addEventListener('scroll', () => {
            if (!queued) {
              queued = true;
              requestAnimationFrame(updateScroll);
            }
          }, { passive: true });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distrigo-seo-page"] && !Shopify.designMode) return;
  try {
    
  const updateFamilyRequestLinks = (scope) => {
    const contentSections = scope.matches?.('[data-distrigo-seo-content]')
      ? [scope]
      : scope.querySelectorAll('[data-distrigo-seo-content]');

    contentSections.forEach((contentSection) => {
      const requestLink = contentSection.dataset.requestLink;
      const requestLabel = contentSection.dataset.requestLabel;

      if (!requestLink || !requestLabel) return;

      contentSection
        .querySelectorAll('a.d-seo-family-action--email, a.d-seo-family-action[href^="mailto:"]')
        .forEach((link) => {
          link.href = requestLink;
          link.textContent = requestLabel;
          link.setAttribute('aria-label', requestLabel);
        });
    });
  };

  updateFamilyRequestLinks(document);

  document.addEventListener('shopify:section:load', (event) => {
    updateFamilyRequestLinks(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
